import type { StartConnectionResponse } from '@polyai/schemas';

import ENDPOINTS from 'api/endpoints';
import { doPost } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';

/**
 * Start a Paragon integration connection
 * This endpoint generates a signed JWT token for authenticating with Paragon
 */
export const startIntegrationConnection = ({
  accountId,
  projectId,
}: {
  accountId: string;
  projectId: string;
}) => {
  const url = generateNextPath(ENDPOINTS.INTEGRATIONS_START_CONNECTION, {
    accountId,
    projectId,
  });

  return doPost<StartConnectionResponse>(
    url,
    LOGGER_TYPE.JUPITER,
    {},
    {
      prefix: 'sourcerer',
    },
  );
};
